//@ts-nocheck
import { grecoServices } from "@greco/services";
import axios from "axios";
import { AzureGraphParams, MSGraphParams } from "../config/GraphConfig";

const graph = require("@microsoft/microsoft-graph-client");

// Only initialize MSGraphAuth if not on invoice payment page
const isInvoicePaymentPage =
  typeof window !== "undefined" &&
  window.location.pathname.startsWith("/invoice-payment/");

export const MSGraphAuth = !isInvoicePaymentPage
  ? new grecoServices.AuthProvider(MSGraphParams)
  : (null as any); // Provide a null placeholder for invoice payment page

export const logout = () => {
  if (MSGraphAuth) {
    MSGraphAuth.logout();
  }
};

async function getAuthenticatedClient() {
  if (!MSGraphAuth) {
    throw new Error("Authentication not available on this page");
  }

  let accessToken: any;
  await MSGraphAuth.getAccessToken().then((token) => {
    accessToken = token;
  });

  // Initialize Graph client
  const client = await graph.Client.init({
    // Use the provided access token to authenticate
    // requests
    authProvider: (done: any) => {
      done(null, accessToken.accessToken);
    },
  });

  return client;
}

export async function getUserDetails(userId?: string = "") {
  const client = await getAuthenticatedClient();

  try {
    const user = await client.api(userId ? "/users/" + userId : "/me").get();

    return user;
  } catch (error) {
    // TODO log error
    return undefined;
  }
}

const readPhotoAsUrl = (blobUrl) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing photo"));
    };

    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blobUrl);
  });
};

export async function getUserPhotoSmall(userId) {
  if (!MSGraphAuth) {
    return "";
  }

  try {
    var token = await MSGraphAuth.getAccessToken(MSGraphParams);
    const response = await axios.get(
      "https://graph.microsoft.com/v1.0/me/photo/$value",
      {
        headers: { Authorization: `Bearer ${token.accessToken}` },
        responseType: "blob",
      }
    );
    return await readPhotoAsUrl(response.data);
  } catch (error) {
    // TODO log error
    return "";
  }
}
